import React from "react";
import loginLogo from "../constants/assests/image/karts-login-logo.png";
import InputFiled from "../shared/inputFiled";
import PasswordFiled from "../shared/passwordFiled";
import FillButton from "../shared/fillButton";

const handleUsernameChange = () => {
  console.log("Username changed");
};

const handlePasswordChange = () => {
  console.log("Password changed");
};

function Register() {
  return (
    <div className="min-h-[100vh] max-h-[100vh] w-screen overflow-x-hidden">
      <div className="flex h-[30vh] justify-center items-center ">
        <img src={loginLogo} width={320} height={320} alt="Login Logo" />
      </div>
      <div className="h-[50vh] flex flex-col justify-center items-center">
        {/* <InputFiled value={username}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}  placeholder="First Name" onChange={handleUsernameChange} />
        <InputFiled placeholder="Last Name" onChange={handleUsernameChange} />
        <InputFiled placeholder="User Name" onChange={handleUsernameChange} />
        <PasswordFiled placeholder="Password" onChange={handlePasswordChange} /> */}
      </div>
      
      <div className=" w-[20]">
      <div className="flex justify-center items-center">
        <a href="/homePage">
          <FillButton name="Login" disabled={false} />
        </a>
      </div>
      <div className="flex justify-center items-center">
        <p className="mt-2">
          Don’t have an account ? <a href="/register"><span className=" font-bold">Sign up</span></a>
        </p>
      </div>
      </div>
    </div>
  );
}

export default Register;
